import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export default {
  getPhones(tckn) {
    return RetailerApiClient.get('applications/findeks/phones?tckn=' + tckn)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  checkPhone(tckn, phone) {
    return RetailerApiClient.post('applications/findeks/check-phone', {
      tckn: tckn,
      phone: phone
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getFindeksPhoneRecords(tckn) {
    return RetailerApiClient.get('applications/findeks/get-phones?tckn=' + tckn)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
